import { createInjectionState, tryOnScopeDispose } from '@vueuse/core';

export const useLocalOnBeforUnload = () => {
    let active = false;
    function beforeUnloadHandler(event: BeforeUnloadEvent) {
        event.preventDefault?.();
        event.returnValue = true;
    }
    function activateOnBeforUnload(activate?: boolean) {
        if(active !== !!activate) {
            if(activate) {
                window.addEventListener('beforeunload', beforeUnloadHandler);
                active = true;
            } else {
                cleanup();
            }
        }
    }
    function cleanup() {
        if(active) {
            window.removeEventListener('beforeunload', beforeUnloadHandler);
            active = false;
        }
    }

    tryOnScopeDispose(cleanup);
    return activateOnBeforUnload;
};

const [useProvideOnBeforUnload, _useGlobalOnBeforUnload] = createInjectionState(() => useLocalOnBeforUnload());

export { useProvideOnBeforUnload };
export function useGlobalOnBeforUnload() {
    return _useGlobalOnBeforUnload() ?? function() {};
}
